const formValidationsI18n = {
  formError: {
    required: 'Field {{fieldName}} is required',
    generalRequired: 'Required',
    conditionalRequired: 'Please provide at least one of the following values: {{fieldNames}}',
    textLength: 'Please provide a longer text',
    minValue: '{{fieldName}} must be greater than {{minAmount}} {{currency}}',
    maxValue: '{{fieldName}} can not be more than {{amount}}',
    positive: 'Number must be positive',
    commentLength: 'Please provide a longer comment',
    atLeastOneValue: 'Please provide at least one value.',
    radioButtonSelectionRequired: 'Please select one option',
    taskRequired: 'At least one task is required',
    provideAmount: 'Past targets need to be closed in appraisal meetings. Please provide an amount.',
    targetAmount: 'Amount exceeds target bonus',
    numberInvalid: 'Invalid number',
    dateInvalid: 'Invalid date',
    dueDateRequired: 'Due date is required',
    dueDateBefore: 'Due date must be after start date',
    startDateAfter: 'Start date must be before due date',
    dateBefore: '"Before date" must be after "{{date}}"',
    fieldName: {
      title: 'title',
      keyResult: 'keyResult',
    },
    dateUndefined: 'Valid from is required',

    // Employment change form specific messages
    salaryCannotBeZero: 'Salary cannot be 0 {{currency}}',
    reducedSalaryMinValue: 'Salary must either be greater than {{minAmount}} {{currency}} or increase bonus to {{minBonus}} {{currency}}.',
    reducedSalaryMinBonusValue:
      'Salary was decreased below the previous value. To compensate bonus must be at least {{minAmount}} {{currency}} or increase salary.',
    reducedBonusMinValue: 'Bonus must either be greater than {{minAmount}} {{currency}} or increase salary to {{minSalary}} {{currency}}.',
    increaseSalaryUpToNationalContract: 'Salary must be greater than minimum salary {{minAmount}} {{currency}} from the national contract.',
    salaryIsSameAsOriginalSalary: 'Salary cannot be the same as the original salary. Change salary or edit target bonus.',
    changeForbiddenDueToApprenticeshipLevel: 'Cannot change national contract reference level while Employment is of type apprenticeship',
    decreaseNationalReferenceLevel: 'It is not possible to decrease the national reference level.',
    salaryPlusBonusDecreasesValue: 'Inserted value (bonus + salary) needs to be higher than or equal to the current one.',
    salaryPlusBonusDecreasesFuturePackage: 'Current bonus and salary would decrease future package of {{minAmount}} {{currency}}',
    salaryCannotBeEqualToTheOneAlreadySetForChangeMonth:
      'Please enter a salary different from the one already set for selected valid from month or leave the field blank.',
    bonusCannotBeEqualToTheOneAlreadySetForChangeMonth:
      'Please enter a bonus different from the one already set for selected valid from month or leave the field blank.',
    increaseSalaryUpForPeriodOfTime:
      'Salary must be greater or equal than the salary for given period of time, {{minAmount}} {{currency}}.',
    salaryMustBeHigherThanPrevious: 'Salary must be greater than the salary for given period of time, {{minAmount}} {{currency}}.',
    increaseBonusUpForPeriodOfTime: 'Bonus must be greater than the bonus for given period of time, {{minAmount}} {{currency}}.',
    employeeLevelCannotBeEqualToCurrent:
      'Please select an employee level different from the one already set for selected valid from month or leave the field blank.',
    employeeGjtAndLevelMustBeDefined: 'Both Government Job Title and Employee Level must be defined.',
    increaseEmployeeLevelUpForPeriodOfTime: 'Employee level must be higher than the employee level for given period of time {{minAmount}}.',
    increaseNationalContractEmployeeLevelUpForPeriodOfTime:
      'National Contract level must be higher or equal than the level for given period of time.',
    validFromDateNotInCurrentYear: 'Valid from date must be in the current year',
    validFromDateIsAfterAllowedMonths: 'Valid from date for the next year must be in first three months',
    validFromDateIsBeforeAllowedMonths: 'Valid from date for the previous year must be in the last three months',
    openChangesAlreadyExist: {
      employeeLevel: 'There are already open changes for EmployeeLevel',
      bonus: 'There are already open changes for Bonus',
      salary: 'There are already open changes for Salary',
      nationalReferenceLevel: 'There are already open changes for National Contract Level',
      governmentJobTitle: 'There are already open changes for Government Job Title',
      validFrom: 'There are already open changes for the provided date',
    },
    updatesRestrictedTo: 'Employment change locked until {{date}}',
    editBonusAmountModal: {
      errorField: 'Please enter an amount between the maximum amount and the prorated amount.',
      errorForm: 'Error on bonus amount',
    },
    nationalReferenceLevelNotAllowed: 'National Reference Level not selectable for the employee.',
    governmentJobTitleNotAllowed: 'Change on Government Job Title is possible for Brazilian employees only.',
    employeeLevelRequired: 'Employee Level must be selected.',
    governmentJobTitleRequired: 'Employee Level must be selected.',
    governmentJobTitleNotFound: 'Selected Government Job Title does not exist.',
    invalidEmployeeLevel: 'Selected Employee level is different from the one associated to the selected Government Job Title',
    contractGovernmentJobTitleNotFound: 'No Contract Government Job Title found for current contract.',
    currentContractGovernmentJobTitleNotFound: 'No current Contract Government Job Title found for current contract.',
    invalidHiringOffice: 'Hiring Office associated to the selected Government Job Title differs from the current one of the employeee.',
    invalidFutureHiringOffice:
      'The employee has future changes involving a Hiring Office which is different from the one associated to the selected Government Job Title',
    bonusNotAllowedInPreviousASYearInAppraisalUpdate: 'The change to the bonus target is not allowed for the selected month.',
  },
}

export { formValidationsI18n }
